// Product ki categories — poori list, aur naam se khud andaza.
// Maqsad: har koi apni marzi ka category na likhe ("baby frock" virtual me chala jata tha).

export const CATEGORIES = [
  { key: 'clothing', icon: '👕', label: 'Clothing & Apparel' },
  { key: 'kids', icon: '🧸', label: 'Kids & Baby' },
  { key: 'shoes', icon: '👟', label: 'Shoes & Footwear' },
  { key: 'bags', icon: '👜', label: 'Bags & Accessories' },
  { key: 'jewelry', icon: '💍', label: 'Jewelry & Watches' },
  { key: 'beauty', icon: '💄', label: 'Beauty & Personal Care' },
  { key: 'health', icon: '🩺', label: 'Health & Wellness' },
  { key: 'electronics', icon: '📱', label: 'Electronics & Gadgets' },
  { key: 'computers', icon: '💻', label: 'Computers & Accessories' },
  { key: 'home', icon: '🏠', label: 'Home & Living' },
  { key: 'kitchen', icon: '🍳', label: 'Kitchen & Dining' },
  { key: 'furniture', icon: '🛋️', label: 'Furniture' },
  { key: 'food', icon: '🍯', label: 'Food & Groceries' },
  { key: 'books', icon: '📚', label: 'Books & Stationery' },
  { key: 'toys', icon: '🎮', label: 'Toys & Games' },
  { key: 'sports', icon: '⚽', label: 'Sports & Outdoors' },
  { key: 'automotive', icon: '🚗', label: 'Automotive' },
  { key: 'tools', icon: '🔧', label: 'Tools & Hardware' },
  { key: 'pets', icon: '🐕', label: 'Pet Supplies' },
  { key: 'art', icon: '🎨', label: 'Art & Crafts' },
  { key: 'garden', icon: '🌱', label: 'Garden & Plants' },
  // Digital
  { key: 'digital_goods', icon: '💾', label: 'Digital Goods & Files' },
  { key: 'software', icon: '🖥️', label: 'Software & Licenses' },
  { key: 'giftcards', icon: '🎟️', label: 'Gift Cards & Vouchers' },
  { key: 'courses', icon: '🎓', label: 'Courses & eBooks' },
  { key: 'services', icon: '🔧', label: 'Services' },
  { key: 'other', icon: '📦', label: 'Other' },
];

// Har category ke lafz — naam me ye milen to wahi category suggest hoti hai.
const HINTS = {
  clothing: ['shirt', 'frock', 'dress', 'kurta', 'shalwar', 'kameez', 'jeans', 'trouser', 'pant', 'jacket', 'coat', 'sweater', 'hoodie', 'top', 'skirt', 'abaya', 'hijab', 'scarf', 'suit', 'blouse', 'lehenga', 'saree', 'shawl', 'apparel', 'clothing', 'wear'],
  kids: ['baby', 'kids', 'toddler', 'infant', 'newborn', 'child', 'diaper', 'nappy', 'stroller', 'pram', 'baby frock', 'romper', 'bib'],
  shoes: ['shoe', 'sandal', 'sneaker', 'boot', 'heel', 'slipper', 'chappal', 'khussa', 'footwear', 'joggers', 'loafer'],
  bags: ['bag', 'handbag', 'backpack', 'purse', 'wallet', 'clutch', 'luggage', 'belt', 'sunglasses'],
  jewelry: ['ring', 'necklace', 'earring', 'bracelet', 'jewelry', 'jewellery', 'watch', 'bangle', 'pendant', 'chain', 'gold', 'silver'],
  beauty: ['makeup', 'lipstick', 'cream', 'lotion', 'perfume', 'shampoo', 'soap', 'cosmetic', 'skincare', 'foundation', 'kajal', 'mascara', 'serum', 'beauty'],
  health: ['vitamin', 'supplement', 'medicine', 'health', 'mask', 'sanitizer', 'thermometer', 'fitness', 'protein', 'first aid'],
  electronics: ['phone', 'mobile', 'charger', 'earbud', 'headphone', 'speaker', 'camera', 'tv', 'television', 'watch', 'smartwatch', 'cable', 'adapter', 'power bank', 'earphone', 'bluetooth', 'gadget', 'electronic'],
  computers: ['laptop', 'computer', 'mouse', 'keyboard', 'monitor', 'ssd', 'ram', 'hard disk', 'usb', 'printer', 'router', 'webcam', 'pc', 'cpu', 'motherboard'],
  home: ['curtain', 'bedsheet', 'blanket', 'pillow', 'towel', 'rug', 'carpet', 'lamp', 'decor', 'clock', 'mirror', 'cushion', 'mattress', 'home'],
  kitchen: ['pot', 'pan', 'plate', 'bowl', 'cup', 'mug', 'knife', 'spoon', 'fork', 'kitchen', 'cookware', 'blender', 'kettle', 'utensil', 'dinner set', 'crockery'],
  furniture: ['chair', 'table', 'sofa', 'bed', 'desk', 'shelf', 'cabinet', 'wardrobe', 'furniture', 'stool', 'couch', 'drawer'],
  food: ['honey', 'oil', 'rice', 'flour', 'tea', 'coffee', 'spice', 'masala', 'snack', 'chocolate', 'biscuit', 'food', 'grocery', 'dates', 'dry fruit', 'ghee', 'sugar', 'pickle', 'jam'],
  books: ['book', 'notebook', 'diary', 'pen', 'pencil', 'stationery', 'quran', 'novel', 'magazine', 'planner', 'journal'],
  toys: ['toy', 'game', 'puzzle', 'doll', 'lego', 'ball', 'car toy', 'board game', 'action figure', 'teddy'],
  sports: ['cricket', 'football', 'bat', 'racket', 'gym', 'dumbbell', 'yoga', 'sports', 'bicycle', 'cycle', 'treadmill', 'jersey', 'skipping'],
  automotive: ['car', 'bike', 'motorcycle', 'tyre', 'engine oil', 'helmet', 'automotive', 'vehicle', 'seat cover', 'car mat'],
  tools: ['drill', 'hammer', 'screwdriver', 'wrench', 'tool', 'plier', 'saw', 'hardware', 'nails', 'tape measure'],
  pets: ['pet', 'dog', 'cat', 'fish', 'bird', 'aquarium', 'pet food', 'leash', 'cage', 'kennel'],
  art: ['paint', 'canvas', 'brush', 'craft', 'art', 'sketch', 'sticker', 'handmade', 'clay', 'calligraphy'],
  garden: ['plant', 'seed', 'pot plant', 'garden', 'flower', 'soil', 'fertilizer', 'sapling', 'gardening'],
  digital_goods: ['file', 'download', 'pdf', 'template', 'digital', 'wallpaper', 'preset', 'font'],
  software: ['software', 'license', 'key', 'activation', 'app', 'plugin', 'subscription', 'antivirus', 'windows', 'office'],
  giftcards: ['gift card', 'voucher', 'coupon', 'top up', 'topup', 'recharge', 'gift', 'redeem', 'scratch'],
  courses: ['course', 'ebook', 'tutorial', 'class', 'lesson', 'training', 'guide', 'masterclass'],
  services: ['service', 'haircut', 'plumber', 'electrician', 'tutor', 'repair', 'cleaning', 'salon', 'massage', 'consultation', 'booking', 'tailor', 'stitching', 'darzi', 'mistri', 'tuition', 'coaching', 'mehndi', 'photography', 'catering', 'car wash', 'ac service', 'home service', 'delivery service'],
};

/**
 * Naam se category ka andaza. Sab se lamba milne wala lafz jeetta hai
 * (taake "baby frock" -> kids, sirf "frock" -> clothing).
 * Return: category key ya '' (kuch na mila).
 */
export function guessCategory(name) {
  const n = (name || '').toLowerCase();
  if (n.length < 2) return '';
  let best = '', bestLen = 0;
  for (const [key, words] of Object.entries(HINTS)) {
    for (const w of words) {
      if (n.includes(w) && w.length > bestLen) {
        best = key;
        bestLen = w.length;
      }
    }
  }
  return best;
}

export function categoryLabel(key) {
  const c = CATEGORIES.find((x) => x.key === key);
  return c ? `${c.icon} ${c.label}` : key;
}
